/**
 * InfinitSales - Notifications Service
 * Client do feed de notificacoes internas (sino + painel).
 */
import api from './api';

const BASE = '/api/notifications';

class NotificationsService {
  /**
   * Lista o feed do usuario. Retorna { items, count, unread, has_more,
   * next_offset }. Suporta filtro por categoria (chip) e paginacao (offset).
   */
  async list({ limit = 50, onlyUnread = false, category = null, offset = 0 } = {}) {
    const params = { limit, only_unread: onlyUnread, offset };
    if (category) params.category = category;
    const res = await api.get(BASE, { params });
    return res.data;
  }

  /** Apenas a contagem de nao lidas (hidratacao leve da bolinha). */
  async unreadCount() {
    const res = await api.get(`${BASE}/unread-count`);
    return res.data?.unread ?? 0;
  }

  /**
   * Cria uma notificacao individual para o proprio usuario.
   * payload: { title, body?, contact_phone?, chat_id?, channel?, icon?, accent_color?, show_toast? }
   */
  async create(payload) {
    const res = await api.post(BASE, payload);
    return res.data;
  }

  async markRead(id) {
    const res = await api.post(`${BASE}/${id}/read`);
    return res.data;
  }

  async markAllRead() {
    const res = await api.post(`${BASE}/read-all`);
    return res.data;
  }

  async remove(id) {
    const res = await api.delete(`${BASE}/${id}`);
    return res.data;
  }
}

const notificationsService = new NotificationsService();
export default notificationsService;
